import { Component, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PageNotificationService, MenuNavigationService, LoginService, ShareDataService } from '@signature-it/ngx-generic/services';
import {UserNavigation} from '@signature-it/ngx-generic/models';
import { MainHeaderUserDetailsComponentGeneric } from "../user-details";

declare let _: any;

@Component({
    selector: 'main-header-user-details',
    templateUrl: './navbar-side.html',
    styleUrls: ['../user-details.scss', './navbar-side.scss'],
    standalone: false
})
export class MainHeaderUserDetailsNavbarComponentGeneric extends MainHeaderUserDetailsComponentGeneric {
    account: UserNavigation;
    submitSpinner: boolean = false;

    constructor(protected loginService: LoginService,
                protected notifySvc: PageNotificationService,
                protected menuSvc: MenuNavigationService,
                protected router: Router,
                public shareDataService: ShareDataService) {
        super(shareDataService);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['user'] && !_.isEmpty(changes['user'])) {
            // user's menu
            const menuList = this.menuSvc.getUserNavigation(this.user);
            this.account = _.filter(menuList, {[UserNavigation.ATTR_NAME]:'Personal Account'})[0] || {};
        }
    }

    logout() {
        this.submitSpinner = true;

        this.loginService
            .logout()
            .subscribe(
            res => {
                // clear storage data and redirect to given url
                sessionStorage.clear();
                this.router.navigate([_.has(res, 'redirect_url') ? res['redirect_url'] : "/"]).then( (e) => location.reload());
            },
            err => {
                this.notifySvc.set(err).show();
                this.submitSpinner = false;
            }
        );
    }

}
